<template>
  <div class="row">
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      :id="`modalSeparate_${group_prescription_care.prescription_care_time.id}`"
      title="CHECAR"
    >
      <Separate
        v-on:success="paginate"
        v-on:checked="$emit('checked')"
        :resident_id="resident_id"
        :date="date"
        :group_prescription_care="group_prescription_care"
      />
    </b-modal>
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      :id="`modalNotSeparate_${group_prescription_care.prescription_care_time.id}`"
      title="NÃO SEPARAR"
    >
      <NotSeparate
        v-on:success="paginate"
        v-on:checked="$emit('checked')"
        :resident_id="resident_id"
        :care_check="group_prescription_care.care_check"
        :group_prescription_care="group_prescription_care"
      />
    </b-modal>
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      :id="`modalCheck_${group_prescription_care.prescription_care_time.id}`"
      title="CHECAR"
    >
      <Check
        v-on:success="paginate"
        v-on:checked="$emit('checked')"
        v-on:cancel="
          $bvModal.hide(
            `modalCheck_${group_prescription_care.prescription_care_time.id}`
          )
        "
        :resident_id="resident_id"
        :date="date"
        :group_prescription_care="group_prescription_care"
        :prescription_care_time="group_prescription_care.prescription_care_time"
        :care_check="group_prescription_care.care_check"
        :stock_id="group_prescription_care.care_check.separate_stock_id"
      />
    </b-modal>
    <div
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex check-justifique-right"
    >
      <div v-if="$store.state.online">
        <div
          v-if="
            group_prescription_care.prescription_care.frequency == 'EVENTUAL'
          "
        >
          <v-btn
            v-if="group_prescription_care.prescription_care.show_separate"
            class="btn-modern btn-modern-add m-1 check-block"
            @click="handleSeparate"
            >CHECAR</v-btn
          >
          <div
            v-for="(item, key) of group_prescription_care.prescription_care
              .quantity_of_times_checked"
            :key="key"
          >
            <v-btn
              v-if="item.status == 'SEPARADO'"
              class="btn-modern btn-modern-delete m-1"
              @click="handleNotSeparate"
              >NÃO SEPARAR</v-btn
            >
            <v-btn
              v-if="item.status == 'SEPARADO'"
              class="btn-modern btn-modern-add m-1"
              @click="handleCheck"
              >CHECAR</v-btn
            >
          </div>
        </div>
        <div
          v-if="
            group_prescription_care.prescription_care.frequency != 'EVENTUAL'
          "
        >
          <v-btn
            v-if="
              !group_prescription_care.care_check.id &&
              group_prescription_care.prescription_care.frequency != 'EVENTUAL'
            "
            class="btn-modern btn-modern-add m-1 check-block"
            @click="handleSeparate"
          >
            CHECAR</v-btn
          >
          <v-btn
            v-if="group_prescription_care.care_check.status == 'SEPARADO'"
            class="btn-modern btn-modern-delete m-1"
            @click="handleNotSeparate"
            >NÃO SEPARAR</v-btn
          >
          <v-btn
            v-if="group_prescription_care.care_check.status == 'SEPARADO'"
            class="btn-modern btn-modern-add m-1"
            @click="handleCheck"
            >CHECAR</v-btn
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Separate from "./Action/Separate";
import NotSeparate from "./Action/NotSeparate";
import Check from "./Action/Check";

export default {
  name: "Action",
  components: { Separate, NotSeparate, Check },
  props: {
    resident_id: [String, Number],
    date: [String, Number],
    group_prescription_care: Object,
  },
  data() {
    return {
      accessed_offline: false,
    };
  },
  created() {
    this.accessed_offline = JSON.parse(
      sessionStorage.getItem("accessed_offline") || !this.$store.state.online
    );
  },
  methods: {
    handleSeparate() {
      let { group_prescription_care } = this;
      this.$bvModal.show(
        `modalSeparate_${group_prescription_care.prescription_care_time.id}`
      );
    },
    handleNotSeparate() {
      let { group_prescription_care } = this;
      this.$bvModal.show(
        `modalNotSeparate_${group_prescription_care.prescription_care_time.id}`
      );
    },
    handleCheck() {
      let { group_prescription_care } = this;
      this.$bvModal.show(
        `modalCheck_${group_prescription_care.prescription_care_time.id}`
      );
    },
    paginate() {
      let { group_prescription_care } = this;
      this.$bvModal.hide(
        `modalSeparate_${group_prescription_care.prescription_care_time.id}`
      );
      this.$bvModal.hide(
        `modalNotSeparate_${group_prescription_care.prescription_care_time.id}`
      );
      this.$bvModal.hide(
        `modalCheck_${group_prescription_care.prescription_care_time.id}`
      );
      this.$emit("success");
    },
  },
};
</script>
